/*jshint esversion: 6 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import fullpage from "v-fullpage";
import 'ant-design-vue/dist/antd.css';
import VueApexCharts from 'vue-apexcharts';
import {
  Alert, AutoComplete, ConfigProvider, Dropdown, Menu, Spin, Table, Modal, Button, DatePicker, 
  message,Slider,InputNumber,Checkbox,Input, Icon, Divider,Select,Pagination, Radio
} from 'ant-design-vue';
import axios from 'axios';
import qs from 'qs';

// ConfigProvider 国际化-->中文引入
import zhCN from 'ant-design-vue/es/locale/zh_CN';
// highlight.js代码高亮插件
import Highlight from './myutils/highlight'; // from 路径是highlight.js的路径，纯属自定义

import Common from './components/common/Common'; // 全局变量信息
import base from './components/common/base';     // 全局函数信息
import bkCommon from './views/bk/bkCommon/bkCommon'; // bk全局变量信息

// 视频插件
import hls from 'videojs-contrib-hls';
import VideoJs from 'video.js';
import 'video.js/dist/video-js.css';
import 'video.js/dist/lang/zh-CN.json';
// import zhCN from './video-zh-CN.json';
import 'videojs-flash'; 
import SWF_URL from 'url-loader!url-loader!videojs-swf/dist/video-js.swf';
// window.videojs = VideoJs;
// require('videojs-contrib-hls/dist/videojs-contrib-hls.js');

// 可视化图表
import echarts from 'echarts';
import loading from '@/components/loading/loading.js';

import _ from 'lodash';
import moment from 'moment';

// 拖动元素注册
import vdr from 'vue-draggable-resizable-gorkys';
// 导入默认样式
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css';
Vue.component('vdr', vdr);

// 地图/图像
import Openseadragon from'openseadragon';
Vue.prototype.$Openseadragon = Openseadragon;

Vue.prototype.$moment = moment;
Vue.prototype.$echarts = echarts;
// 设置flash路径，Video.js会在不支持html5的浏览中使用flash播放视频文件
VideoJs.options.flash.swf = SWF_URL;
// 加载loading
Vue.use(loading);
// VideoJs.addLanguage('zh-CN', zhCN);// 添加中文支持
Vue.use(hls);
Vue.use(Highlight);
Vue.prototype.Common = Common;
Vue.prototype.bkCommon = bkCommon;
Vue.prototype.$user = null;
Vue.use(base);
Vue.prototype.$VideoJs = VideoJs;

Vue.prototype.$axios   = axios;
Vue.prototype.$qs      = qs;
Vue.prototype._        = _;
Vue.prototype.$message = message;
Vue.prototype.$locale  = zhCN;
Vue.prototype.$Modal   = Modal;
Vue.use(Alert);
Vue.use(AutoComplete);
Vue.use(ConfigProvider);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Spin);
Vue.use(Table);
Vue.use(Modal);
Vue.use(Button);
Vue.use(DatePicker);
Vue.use(InputNumber);
Vue.use(Slider);
Vue.use(Checkbox);
Vue.use(Divider);
Vue.use(Icon);
Vue.use(VueApexCharts);
Vue.use(Input);
Vue.use(Select);
Vue.use(Pagination);
Vue.use(Radio);
Vue.use(fullpage);

Vue.config.productionTip = false;
Vue.component('apexchart', VueApexCharts);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
